import { useState, lazy, Suspense } from 'react';
import './App.scss';
// import AlertPopup from "../src/Components/Global_Components/Popup/alert";
import { useSelector } from 'react-redux';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import CircularIndeterminate from '../src/Components/Global_Components/loader/progressloader';
import ActionAlerts from '../src/Components/Global_Components/popupalert/popupalert';
import SideBar from '../src/Components/Sidenav';
import Navbar from './Components/Navbar';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import PrivateRoutes from './Pages/Login/Privaterouters';
// import { admincreate } from "./Context/apiData";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/js/bootstrap.js';
import 'font-awesome/css/font-awesome.min.css';
import 'rsuite/dist/rsuite.css';

// Lazy-loaded page components
const PatientView = lazy(() => import('./Pages/patientsView'));
const AddFertility = lazy(() => import('./Components/AddFertility'));
const BillGenerate = lazy(() => import('./Components/BillGenerate'));
const DIFReport = lazy(() => import('./Components/DIFReport'));
const IUIReport = lazy(() => import('./Components/IUIReport'));
const SemenAnalysis = lazy(() => import('./Components/SemenAnalysis'));
const SemenFreezing = lazy(() => import('./Components/SemenFreezing'));
const PrescriptionShare = lazy(() => import('./Components/Share/PrescriptionShare'));
const DeliveryAdmissionForm = lazy(() => import('./Components/Template_page/DeliveryAdmissionForm'));
const DeliveryEssentials = lazy(() => import('./Components/Template_page/deliveryessentials'));
const LayoutInPatient = lazy(() => import('./Layout/LayoutInPatient'));
const BillReportDetails = lazy(() => import('./Pages/BillReportDetails'));
const Charts = lazy(() => import('./Pages/Charts'));
const ConsultationReport = lazy(() => import('./Pages/ConsultationReport'));
const CreateUser = lazy(() => import('./Pages/CreateUser'));
const DrugInventory = lazy(() => import('./Pages/DrugInventory/DrugInventory'));
const Dashboard = lazy(() => import('./Pages/Fertility/chart/Dashboard'));
const Fertility = lazy(() => import('./Pages/Fertility/Fertility'));
const FertilityView = lazy(() => import('./Pages/Fertility/FertilityView'));
const InjectionReport = lazy(() => import('./Pages/InjectionReport'));
const InPatientSchedule = lazy(() => import('./Pages/InPatientSchedule/InPatientSchedule'));
const View = lazy(() => import('./Pages/InPatientSchedule/View'));
const OtReport = lazy(() => import('./Pages/OtReport'));
const Patents = lazy(() => import('./Pages/Patents'));
const PatientAppointment = lazy(() => import('./Pages/PatientAppointment'));
const PatientBilling = lazy(() => import('./Pages/PatientBilling'));
const PatientReports = lazy(() => import('./Pages/PatientReports'));
const PatientTemplates = lazy(() => import('./Pages/Patienttemplates'));
const PharmacyReport = lazy(() => import('./Pages/PharmacyReport'));
const Prescription = lazy(() => import('./Pages/Prescription'));
const Embryologist = lazy(() => import('./Pages/Embryologist/Embryologist'));
const IPBilling = lazy(() => import('./Pages/IPBilling/IPBilling'));
const DischargeSummary = lazy(() => import('./Pages/DischargeSummary/DischargeSummary'));
const ProcedureReport = lazy(() => import('./Pages/ProcedureReport'));
const ReportView = lazy(() => import('./Pages/ReportView'));
const ScanReport = lazy(() => import('./Pages/ScanReport'));
const ViewPatientReport = lazy(() => import('./Pages/ViewPatientReport'));
const ViewPrescriptionHistory = lazy(() => import('./Pages/viewPrescriptionHistory'));

const SuspenseFallback = (
  <div
    className='loader'
    style={{
      position: 'absolute',
      height: '100%',
      width: '100%',
      zIndex: '999'
    }}>
    <CircularIndeterminate />
  </div>
);

function App() {
  const Error = useNavigate();
  const loaderdata = useSelector(state => state.counter.loader);
  const popup = useSelector(state => state.counter.popupalert);
  const [alertpopuptext, setalertpopuptext] = useState('');
  const [loader, setLoader] = useState(loaderdata);
  const location = useLocation();
  const isShareUrl = location.pathname.includes('/share/');
  const [alertpopup, setalertpopup] = useState(popup);
  const [errorstatus, seterrorstatus] = useState('');
  var logintest = localStorage.getItem('login');
  const loaderchange = arg => {
    setLoader(arg);
  };
  const popupalert = arg => {
    setalertpopup(arg);
  };
  const popuptext = arg => {
    setalertpopuptext(arg);
  };

  return (
    <div className='App'>
      {loader == 'true' ? (
        <div
          className='loader'
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            zIndex: '999'
          }}>
          <CircularIndeterminate />
        </div>
      ) : (
        ''
      )}

      {alertpopup == 'true' ? <ActionAlerts alertpopuptext={alertpopuptext} popupalert={popupalert} /> : ''}

      <>
        {logintest == 'false' ? (
          <>
            {!isShareUrl && (
              <>
                <Navbar popupalert={popupalert} popuptext={popuptext} />
                <SideBar />
              </>
            )}
            <Suspense fallback={SuspenseFallback}>
              <Routes>
                <Route path='/' element={<Home loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/patienttemplates' element={<PatientTemplates loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/Patients' element={<Patents loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/PatientView' element={<PatientView loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/prescription' element={<Prescription loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/charts' element={<Charts loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/charts/:type' element={<Charts loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />

                <Route path='/viewHistory' element={<ViewPrescriptionHistory loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/patient_billing' element={<PatientBilling loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/appointment' element={<PatientAppointment loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/druginventory' element={<DrugInventory loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/inpatient' element={<LayoutInPatient />}>
                  <Route index element={<InPatientSchedule loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                  <Route path='view' element={<View loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                </Route>
                <Route path='/fertility' element={<LayoutInPatient />}>
                  <Route index element={<Fertility loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                  <Route path='add' element={<AddFertility loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                  <Route path='view' element={<FertilityView loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                  <Route path='analytics' element={<Dashboard loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                </Route>
                <Route path='/embryologist' element={<Embryologist />} />
                <Route path='/embryologist/*' element={<Embryologist />} />
                <Route path='/ipbilling' element={<IPBilling />} />
                <Route path='/ipbilling/*' element={<IPBilling />} />
                <Route path='/discharge-summary' element={<DischargeSummary />} />
                <Route path='/discharge-summary/*' element={<DischargeSummary />} />
                <Route path='/user_list' element={<CreateUser loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/bill_create' element={<BillGenerate loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/reportview' element={<ViewPatientReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/share/:id' element={<PrescriptionShare loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />

                {/*----templates---*/}
                <Route path='/patientreports' element={<PatientReports loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/reportcreate/SemenAnalysis' element={<SemenAnalysis loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/reportcreate/SemenFreezing' element={<SemenFreezing loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/reportcreate/dfi-report' element={<DIFReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/reportcreate/iui-report' element={<IUIReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='/reportcreate/deliveryadmissionform' element={<DeliveryAdmissionForm loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/reportcreate/deliveryessentials' element={<DeliveryEssentials loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/reportDetails/reportView' element={<ReportView loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/reportDetails' element={<BillReportDetails loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/reportDetails/pharmacy' element={<PharmacyReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/scan_report' element={<ScanReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/procedure_report' element={<ProcedureReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/consultation_report' element={<ConsultationReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/injection_report' element={<InjectionReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
                <Route path='/ot_report' element={<OtReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              </Routes>
            </Suspense>
          </>
        ) : (
          <Routes>
            <Route element={<PrivateRoutes />} path='/' exact />
            {/* <Route
              path="/login"
              element={
                <Reportscreatepage
                  loaderchange={loaderchange}
                  popupalert={popupalert}
                  popuptext={popuptext}
                />
              }
            /> */}
            <Route path='/login' element={<Login loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
          </Routes>
        )}
      </>
    </div>
  );
}

export default App;
